import styled from 'styled-components';
import { media } from '../../../Utils/mediaQueries';
import { Link } from 'react-router-dom';

export const TopLineMenu = styled.div`
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;

    ${media.tablet`
        flex-wrap: wrap;    
    `};
`;

export const HorizontalMargin = styled.div`
    margin: 0 20px 0 0;
`;

export const TopLine = styled.div`
    width: 100%;
    height: 45px;
    background-color: #0e0e0e;
    position: relative;
    box-shadow: inset 0 -1px 0 0 #1b1b1b;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 16px;
    position: fixed;
    top: 0;
    z-index: 10000;
`;

export const TopMobileLine = styled.div`
    width: 100%;
    height: 45px;
    background-color: #0e0e0e;
    position: relative;
    box-shadow: inset 0 -1px 0 0 #1b1b1b;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 16px;
    position: fixed;
    top: 0;
    z-index: 10000;
`;

export const TabItem = styled.div`
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    // flex: 1;
    cursor: pointer;
    padding: 0 15px;
    text-decoration: none;
    padding: 0 5px;

    // transition: all ease-in 0.5s;

    color: white;
    font-size: 14px;
    font-weight: 200;

    &.active {
        box-sizing: content-box;
        border-bottom: 2px solid #f84c56;
        font-weight: 550;
    }
`;

export const StyledLink = styled(Link)`
    width: 100%;
    height: 100%;
    color: white;
    font-size: 14px;
    font-weight: 200;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const HoverableLink = styled(Link)`
    transition: all 0.5s ease;
    cursor: pointer;
    color: white;
    font-size: 14px;

    &:hover {
        opacity: 0.7;
    }
`;



// WEBPACK FOOTER //
// ./src/UI/Components/TopMenu/style.js